import React from 'react';

const SIZE_CLASSES = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-[3px]',
};

export const Spinner: React.FC<{ size?: keyof typeof SIZE_CLASSES; className?: string }> = ({
  size = 'md',
  className = '',
}) => (
  <div
    className={`animate-spin rounded-full border-slate-200 border-t-brand-600 ${SIZE_CLASSES[size]} ${className}`}
    role="status"
    aria-label="Cargando"
  />
);

export const LoadingState: React.FC<{ label?: string; className?: string }> = ({
  label = 'Cargando...',
  className = '',
}) => (
  <div className={`flex flex-col items-center justify-center gap-3 py-12 text-slate-500 ${className}`}>
    <Spinner size="lg" />
    <p className="text-sm">{label}</p>
  </div>
);

export default Spinner;
